"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = _interopRequireDefault(require("baseStyles/enums/fonts"));
var _types = require("./types");
var _styles = _interopRequireDefault(require("./styles"));
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _excluded = ["children", "type", "dataTestId", "onClick"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TextSpan = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-style: ", ";\n    width: ", ";\n    max-width: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    color: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    opacity: ", ";\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n     ", "\n\n    :hover {\n      ", ";\n"])), _fonts["default"].Family.GRAPHIE, _fonts["default"].Style.NORMAL, function (props) {
  return props.width ? "".concat(props.width, "px") : 'max-content';
}, function (props) {
  return props.maxWidth ? "".concat(props.maxWidth, "px") : 'max-content';
}, function (props) {
  return "".concat(props.fontSize, "px");
}, function (props) {
  return "".concat(props.fontWeight);
}, function (props) {
  return "".concat(props.lineHeight, "px");
}, function (props) {
  return "".concat(props.letterSpacing || 0, "px");
}, function (props) {
  var _props$theme;
  return props.color || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colorPrimary);
}, function (props) {
  return props.fullWidth && "width: 100%;";
}, function (props) {
  return (props.width || props.fullWidth || (props === null || props === void 0 ? void 0 : props.maxWidth)) && "\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    ";
}, function (props) {
  var _props$theme2, _props$theme3, _props$theme4;
  return props.cta && "\n        text-decoration: underline;\n        cursor: ".concat(props.disabled ? 'default' : 'pointer', ";\n        color: ").concat(props.color ? props.color : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.colorLink, ";\n        ").concat(props.disabled && "\n          color: ".concat((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.colorLinkDisabled, ";\n        "), "\n        transition: color .5s;\n\n        &:hover {\n          color: ").concat((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.colorLinkHover, ";\n        }\n    ");
}, function (props) {
  return props.noUnderline && "\n      text-decoration: none;\n    ";
}, function (props) {
  return props.disabled && "\n      pointer-events: none;\n      cursor: default;\n    ";
}, function (props) {
  return props.center && "\n      text-align: center;\n    ";
}, function (props) {
  return props.emphasis && "\n      font-weight: ".concat(props.fontWeight === _fonts["default"].Weight.W600 ? _fonts["default"].Weight.W700 : _fonts["default"].Weight.W600, ";\n    ");
}, function (props) {
  return props.opacity || 1;
}, function (props) {
  return props.whiteSpace && " \n      white-space: ".concat(props.whiteSpace, ";\n    ");
}, function (props) {
  return props.lines && "\n      display: -webkit-box; \n      -webkit-box-orient: vertical; \n      -webkit-line-clamp: ".concat(props.lines, "; \n      white-space: break-spaces;\n      word-wrap: break-word;\n    ");
}, function (props) {
  return props.inlineMaxWidth && "\n        max-width: ".concat(props.inlineMaxWidth, ";\n        display: inline-block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        vertical-align: bottom;\n    ");
}, function (props) {
  return props.notSelectable && "\n        user-select: none;\n    ";
}, function (props) {
  return props.textAlign && "\n        text-align: ".concat(props.textAlign, ";\n    ");
}, function (props) {
  return props.textDecoration && "\n       text-decoration: ".concat(props.textDecoration, ";\n    ");
}, function (props) {
  return props.hoverColor && "\n      color: ".concat(props.hoverColor, ";\n    ");
});
var Text = function Text(_ref) {
  var children = _ref.children,
    type = _ref.type,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = (0, _styles["default"])();
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  return /*#__PURE__*/_react["default"].createElement(TextSpan, _extends({
    onClick: onClick,
    "data-test-id": dataTestId,
    className: "sui-text"
  }, styles[type] || styles.NORMAL, {
    theme: theme
  }, props, {
    "data-sentry-element": "TextSpan",
    "data-sentry-component": "Text",
    "data-sentry-source-file": "index.tsx"
  }), children);
};
Text[_types.TextStylesTypes.HS1] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.HS1
  }, props));
};
Text[_types.TextStylesTypes.HS2] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.HS2
  }, props));
};
Text[_types.TextStylesTypes.H1] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H1
  }, props));
};
Text[_types.TextStylesTypes.H2] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H2
  }, props));
};
Text[_types.TextStylesTypes.H3] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H3
  }, props));
};
Text[_types.TextStylesTypes.H4] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H4
  }, props));
};
Text[_types.TextStylesTypes.NORMAL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.NORMAL
  }, props));
};
Text[_types.TextStylesTypes.SMALL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.SMALL
  }, props));
};
Text[_types.TextStylesTypes.CAPTION] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.CAPTION
  }, props));
};
Text[_types.TextStylesTypes.FOOTER] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.FOOTER
  }, props));
};
var _default = Text;
exports["default"] = _default;